import React from "react";
import {
    Page,
    Text,
    View,
    Document,
    StyleSheet,
    Image,
} from "@react-pdf/renderer";

// Styles
const styles = StyleSheet.create({
    // page: {
    //     padding: 20,
    //     fontSize: 10,
    // },
    page: {
        paddingTop: 90,
        paddingBottom: 80,
        paddingHorizontal: 20,
        fontSize: 10,
    },
    section: {
        marginBottom: 10,
    },
    headerContainer: {
        alignItems: 'center',
        justifyContent: 'flex-start',
        marginTop: 20,
    },
    headerText: {
        fontSize: 12,
        fontWeight: 'bold',
        textAlign: "center",
        marginBottom: 10
    },
    prmText: {
        width: "100%",
        fontSize: 10,
        fontWeight: "bold",
        marginTop: 10,
        marginBottom: 10,
        textAlign: "left",
    },
    table: {
        display: "table",
        width: "100%",
        borderWidth: 1,
        borderColor: "#000",
        borderStyle: "solid",
    },
    tableRow: {
        flexDirection: "row",
        borderBottomWidth: 1,
        borderBottomColor: "#000",
        borderBottomStyle: "solid",
    },
    tableRowLast: {
        flexDirection: "row",
    },
    tableColHeader: {
        width: "20%",
        borderRightWidth: 1,
        borderRightColor: "#000",
        padding: 5,
        fontWeight: "bold",
        backgroundColor: "#EEE",
        textAlign: "center",
    },
    tableCol3Header: {
        width: "30%",
        borderRightWidth: 1,
        borderRightColor: "#000",
        padding: 5,
        fontWeight: "bold",
        backgroundColor: "#EEE",
        textAlign: "center",
    },
    tableCol2Header: {
        width: "10%",
        borderRightWidth: 1,
        borderRightColor: "#000",
        padding: 5,
        fontWeight: "bold",
        backgroundColor: "#EEE",
        textAlign: "center",
    },
    tableColHeader1: {
        width: "5%",
        borderRightWidth: 1,
        borderRightColor: "#000",
        padding: 5,
        fontWeight: "bold",
        backgroundColor: "#EEE",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
    },
    tableColHeaderLast: {
        width: "15%",
        padding: 5,
        fontWeight: "bold",
        backgroundColor: "#EEE",
        textAlign: "center",
    },
    tableCol3: {
        width: "30%",
        borderRightWidth: 1,
        borderRightColor: "#000",
        padding: 5,
        textAlign: "left",
    },
    tableCol: {
        width: "20%",
        borderRightWidth: 1,
        borderRightColor: "#000",
        padding: 5,
        textAlign: "left",
    },
    tableCol2: {
        width: "10%",
        borderRightWidth: 1,
        borderRightColor: "#000",
        padding: 5,
        textAlign: "left",
    },
    tableCol1: {
        width: "5%",
        borderRightWidth: 1,
        borderRightColor: "#000",
        padding: 5,
        justifyContent: "center",
        alignItems: "center",
        textAlign: "right",
    },
    tableColLast: {
        width: "15%",
        padding: 5,
    },
    /* HEADER */
    headerWrapper: {
        position: "absolute",
        top: 20,
        left: 20,
        right: 20,
        height: 60,
        justifyContent: "center",
        alignItems: "center",
    },

    headerImage: {
        width: "100%",
        height: 60,
        objectFit: "contain",
    },
    /* FOOTER */
    footerWrapper: {
        position: "absolute",
        bottom: 30,
        left: 5,
        right: 5,     // forces full width
        height: 60,
        justifyContent: "center",
        alignItems: "center",
    },

    footerImage: {
        width: "100%",
        height: 100,
        objectFit: "cover",
    },

    sectionContainer: {
        marginTop: 10,
        padding: 10,
        breakInside: "avoid",
    },

    SummheaderText: {
        fontSize: 20,
        fontWeight: "bold",
        marginBottom: 8,
        textAlign: "center",
        color: "#0B3D91",
        // textDecoration: "underline",
    },

    card: {
        marginBottom: 10,
        padding: 8,
        borderRadius: 5,
        border: "1px solid #ccc",
        backgroundColor: "#F9FBFF",
    },

    listTitle: {
        fontSize: 12,
        fontWeight: "bold",
        marginBottom: 5,
        color: "#1A237E",
        borderBottom: "1px solid #ddd",
        paddingBottom: 2,
    },

    listText: {
        fontSize: 10,
        marginLeft: 10,
        marginBottom: 2,
        color: "#333",
    },

    emptyText: {
        fontSize: 10,
        fontStyle: "italic",
        color: "#999",
        marginLeft: 10,
    },
});



// Split data: 20 on first page, 26 afterwards
// const paginateData = (data) => {
//     const firstPage = data.slice(0, 31);
//     const otherPages = [];

//     for (let i = 31; i < data.length; i += 26) {
//         otherPages.push(data.slice(i, i + 26));
//     }

//     return [firstPage, ...otherPages];
// };

// Split data: 15 on first page, 17 afterwards

const paginateData = (data) => {
    const firstPage = data.slice(0, 15);
    const otherPages = [];

    for (let i = 15; i < data.length; i += 17) {
        otherPages.push(data.slice(i, i + 17));
    }

    return [firstPage, ...otherPages];
};

const DailyattendancePDF = ({ data = [], filters = {}, footerHeight }) => {
    const pages = paginateData(data);
    pages.forEach((page, i) => {
        console.log(`Page ${i + 1} first row index:`, data.indexOf(page[0]));
    });
    const formattedDate = filters.Date
        ? filters.Date.split("-").reverse().join("-")
        : "";
    const isSelf = filters.Self === "Y";


    const dynamicHeaderStyles = {
        col1: {
            ...styles.tableColHeader1,
            width: "6.5%"
        },
        colDate: {
            ...styles.tableColHeader,
            width: "24%"
        },
        colCheckIn: {
            ...styles.tableColHeader,
            width: "20%"
        },
        colCheckOut: {
            ...styles.tableColHeader,
            width: "20%"
        },
        colHours: {
            ...styles.tableCol2Header,
            width: "17%"
        },
        colStatus: {
            ...styles.tableColHeaderLast,
            width: "13%"
        },
        colName: {
            ...styles.tableCol3Header,
            display: filters.Self === "Y" ? "none" : "block"
        }
    };

    const dynamicRowStyles = {
        col1: {
            ...styles.tableCol1,
            width: "6.5%"
        },
        colDate: {
            ...styles.tableCol,
            width: "24%"
        },
        colCheckIn: {
            ...styles.tableCol,
            width: "20%"
        },
        colCheckOut: {
            ...styles.tableCol,
            width: "20%"
        },
        colHours: {
            ...styles.tableCol2,
            width: "17%"
        },
        colStatus: {
            ...styles.tableColLast,
            width: "13%"
        },
        colName: {
            ...styles.tableCol3,
            display: filters.Self === "Y" ? "none" : "block"
        }
    };

    const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    const QR_BASE_URL = `${filters?.Imageurl}/uploads/images/`;  // your image folder path
    // const QR_BASE_URL = "https://uaam.beyondexs.com/uploads/images/";
    const headerPath = filters?.HeaderImg
        ? `${QR_BASE_URL}${filters.HeaderImg}`
        : null;
    const footerPath = filters?.FooterImg
        ? `${QR_BASE_URL}${filters.FooterImg}`
        : null;



    // ✅ Updated Permission Employees mapping
    // Helper function for dd-mm-yyyy
    const formatDateDisplay = (dateStr) => {
        if (!dateStr || dateStr === "-") return "-";
        const datePart = dateStr.split(" ")[0];
        const [year, month, day] = datePart.split("-");
        return `${day}-${month}-${year}`;
    };

    // Update mappings to use 'name' and 'date'
    const permissionList = data
        .filter(r => r.Permission && r.Permission !== "00:00")
        .map(r => {
            console.log(r, "--hii permissionList");  // ✅ valid here

            return {
                name: r.EmpName,
                date: formatDateDisplay(r.CheckInDate)
            };
        });

    const scheduledLeaveList = data
        .filter(r => r.Status === "Leave")
        .map(r => ({
            name: r.EmpName,
            date: formatDateDisplay(r.CheckInDate)
        }));

    const unscheduledLeaveList = data
        .filter(r => r.Status === "Absent")
        .map(r => ({
            name: r.EmpName,
            date: formatDateDisplay(r.CheckInDate)
        }));
    // const permissionList = data
    //   .filter(r => r.Permission && r.Permission !== "00:00")
    //   .map(r => ({ name: r.EmpName, date: r.CheckInDate })); // Store as object

    // // ✅ Updated Scheduled Leave mapping
    // const scheduledLeaveList = data
    //   .filter(r => r.Status === "Leave")
    //   .map(r => ({ name: r.EmpName, date: r.CheckInDate }));

    // // ✅ Updated Unscheduled Leave mapping
    // const unscheduledLeaveList = data
    //   .filter(r => r.Status === "Absent")
    //   .map(r => ({ name: r.EmpName, date: r.CheckInDate }));

    // ✅ Permission Employees
    // const permissionList = data
    //   .filter(r => r.Permission && r.Permission !== "00:00")
    //   .map(r => r.EmpName);

    // // ✅ Scheduled Leave (example condition - adjust based on your API)
    // const scheduledLeaveList = data
    //   .filter(r => r.Status === "Leave")
    //   .map(r => r.EmpName);

    // // ✅ Unscheduled Leave
    // const unscheduledLeaveList = data
    //   .filter(r => r.Status === "Absent")
    //   .map(r => r.EmpName);








    return (
        <Document>
            {pages.map((pageData, pageIndex) => (
                <Page
                    size="A4"
                    // style={styles.page}
                    style={{
                        fontFamily: "Helvetica",
                        fontSize: 10,
                        // backgroundColor: "#ffffff",
                        paddingTop: 80,
                        // paddingBottom: 36,
                        paddingBottom: footerHeight,
                        paddingHorizontal: 20,
                    }}
                    key={pageIndex}>
                    <View fixed style={styles.headerWrapper}>
                        {headerPath ? (
                            <Image src={headerPath} style={styles.headerImage} />
                        ) : (
                            <View style={{ width: "100%", height: 60, backgroundColor: "#eee" }} />
                        )}
                    </View>
                    {pageIndex === 0 && (
                        <View style={styles.headerContainer}>
                            {/* <Text style={styles.headerText}>
                {`Attendance Report - ${filters.EmployeeID} (${monthNames[filters.Month - 1]} - ${filters.Year})`}
              </Text> */}
                            {/* <Text style={styles.headerText}>
                {filters.Date
                  ? `Attendance Report ${filters.EmployeeID} (${formattedDate})`
                  : `Attendance Report - ${filters.EmployeeID} (${monthNames[filters.Month - 1]} - ${filters.Year})`}
              </Text> */}
                            <Text style={styles.headerText}>
                                {filters.Self === "Y"
                                    ? `Daily Attendance Report - ${filters.EmployeeID} (${formattedDate})`
                                    : filters.Self === "N"
                                        ? `Daily Attendance Report - Reporting to ${filters.EmployeeID} (${formattedDate})`
                                        : `Daily Attendance Report - ${filters.EmployeeID} (${formattedDate})`}
                            </Text>
                            <Text style={styles.prmText}>
                                Prm - Permission
                            </Text>

                        </View>

                    )}

                    {/* Table Header */}
                    <View style={styles.table}>
                        {/* <View style={styles.tableRow}>
              <Text style={styles.tableCol1}>S.No</Text>
              {filters.Self === "N" && ( <Text style={styles.tableCol3Header}>Employee Name</Text>)}
              <Text style={dynamicStyles.colCheckIn}>Check In</Text>
              <Text style={dynamicStyles.colCheckOut}>Check Out</Text>
              <Text style={dynamicStyles.colHours}>Hrs</Text>
              <Text style={dynamicStyles.colStatus}>Status</Text>
            </View> */}
                        <View style={styles.tableRow}>
                            <Text style={dynamicHeaderStyles.col1}>SL#</Text>
                            <Text style={dynamicHeaderStyles.colDate}>Name</Text>
                            <Text style={dynamicHeaderStyles.colCheckIn}>Shift Name1</Text>
                            {/* <Text style={dynamicHeaderStyles.colCheckIn}>Shift Name2</Text> */}
                            <Text style={dynamicHeaderStyles.colCheckIn}>In Time</Text>
                            <Text style={dynamicHeaderStyles.colCheckOut}>Out Time</Text>
                            <Text style={dynamicHeaderStyles.colHours}>Worked Hours</Text>
                            <Text style={dynamicHeaderStyles.colHours}>Prm (In Minutes)</Text>
                            <Text style={dynamicHeaderStyles.colStatus}>Status</Text>
                        </View>

                        {pageData.map((row, rowIndex) => {
                            const isLast = rowIndex === pageData.length - 1;
                            return (
                                <View key={rowIndex} style={isLast ? styles.tableRowLast : styles.tableRow}>
                                    <Text style={dynamicRowStyles.col1}>{row.SLNO}</Text>
                                    <Text style={dynamicRowStyles.colDate}>{row.Name}</Text>
                                    <Text style={dynamicRowStyles.colCheckIn}>{row.ShiftName1}</Text>
                                    {/* <Text style={dynamicRowStyles.colCheckIn}>{row.ShiftName2}</Text> */}
                                    <Text style={dynamicRowStyles.colCheckIn}>{row.EmplyeeCheckInDateTime}</Text>
                                    <Text style={dynamicRowStyles.colCheckOut}>{row.EmplyeeCheckOutDateTime}</Text>
                                    <Text style={dynamicRowStyles.colHours}>{row.NumberOfHoursWorked}</Text>
                                    <Text style={dynamicRowStyles.colHours}>{row.Permission}</Text>
                                    <Text style={dynamicRowStyles.colStatus}>{row.Status}</Text>
                                    {/* <Text style={dynamicRowStyles.colStatus}>{row.Comments}</Text> */}
                                </View>
                            );
                        })}

                    </View>


                    <View
                        fixed
                        // style={styles.footerWrapper}

                        style={{
                            position: "absolute",
                            bottom: 30,
                            left: 0,
                            right: 0,
                            height: footerHeight, // 🔥 dynamic
                        }}>
                        {footerPath ? (
                            <Image
                                src={footerPath}
                                // style={styles.footerImage} 
                                style={{
                                    width: "100%",
                                    height: "100%",
                                }}
                            />
                        ) : (
                            <View style={{ width: "100%", height: 50, backgroundColor: "#eee" }} />
                        )}
                    </View>
                    <View
                        fixed
                        style={{
                            position: "absolute",
                            bottom: 10,
                            left: 0,
                            right: 0,
                            textAlign: "center",
                            fontSize: 10,
                        }}
                    >
                        <Text>Page {pageIndex + 1} of {pages.length}</Text>
                    </View>





                    {/* ✅ Summary Page Section */}
                    {pageIndex === pages.length - 1 && (
                        <View style={styles.sectionContainer}>
                            <Text style={styles.SummheaderText}>Summary</Text>

                            {/* ✅ Permission */}
                            {permissionList?.length > 0 && (
                                <View style={styles.card} wrap={false}>
                                    <Text style={styles.listTitle}>
                                        Permission List ({permissionList.length})
                                    </Text>
                                    {permissionList.map((item, i) => (
                                        <Text key={i} style={styles.listText}>
                                            • {item.name}
                                        </Text>
                                    ))}
                                </View>
                            )}

                            {/* ✅ Scheduled Leave */}
                            {scheduledLeaveList?.length > 0 && (
                                <View style={styles.card} wrap={false}>
                                    <Text style={styles.listTitle}>
                                        Scheduled Leave ({scheduledLeaveList.length})
                                    </Text>
                                    {scheduledLeaveList.map((item, i) => (
                                        <Text key={i} style={styles.listText}>
                                            {/* • {item.name} - {formattedDate} */}
                                            • {item.name}
                                        </Text>
                                    ))}
                                </View>
                            )}

                            {/* ✅ Unscheduled Leave */}
                            {unscheduledLeaveList?.length > 0 && (
                                <View style={styles.card} wrap={false}>
                                    <Text style={styles.listTitle}>
                                        Unscheduled Leave ({unscheduledLeaveList.length})
                                    </Text>
                                    {unscheduledLeaveList.map((item, i) => (
                                        <Text key={i} style={styles.listText}>
                                            • {item.name}
                                        </Text>
                                    ))}
                                </View>
                            )}
                        </View>
                    )}


                </Page>
            ))}
        </Document>
    );
};

export default DailyattendancePDF;
